export const YearTabs = ({ years, year, setYear, testid = "year-tabs" }) => (
  <div className="flex gap-2 overflow-x-auto px-4 pb-3 no-scrollbar" data-testid={testid}>
    {[[null, "Current"], ...years.map((y) => [y, String(y)])].map(([y, label]) => (
      <button key={label} data-testid={`year-tab-${label.toLowerCase()}`} onClick={() => setYear(y)}
        className={`whitespace-nowrap rounded-lg px-4 py-2 font-display text-base font-bold transition-colors ${year === y ? "bg-primary text-primary-foreground" : "border border-border bg-card text-primary"}`}>{label}</button>
    ))}
    <span className="w-3 shrink-0" aria-hidden />
  </div>
);
